import type { Structure } from '@wix/thunderbolt-becky-types'

export const getBaseStructure: () => Structure = () => ({
	DYNAMIC_STRUCTURE_CONTAINER: {
		components: [],
		componentType: 'DynamicStructureContainer',
		id: 'DYNAMIC_STRUCTURE_CONTAINER',
		type: 'Component',
		layout: {},
		metaData: {},
		parent: null,
		styleId: '',
	},
	'site-root': {
		components: ['masterPage'],
		componentType: 'DivWithChildren',
		id: 'site-root',
		type: 'Component',
		layout: {},
		metaData: {},
		parent: null,
		styleId: '',
	},
	masterPage: {
		components: [],
		componentType: 'MasterPage',
		id: 'masterPage',
		type: 'Component',
		layout: {},
		metaData: {},
		parent: null,
		styleId: '',
	},
	SITE_STYLES: {
		components: [],
		componentType: 'SiteStyles',
		id: 'SITE_STYLES',
		type: 'Component',
		layout: {},
		metaData: {},
		parent: null,
		styleId: '',
	},
	CUSTOM_CSS: {
		components: [],
		componentType: 'SiteStyles',
		id: 'CUSTOM_CSS',
		type: 'Component',
		layout: {},
		metaData: {},
		parent: null,
		styleId: '',
	},
	SCROLL_TO_TOP: {
		type: 'Component',
		layout: {},
		metaData: {},
		parent: null,
		styleId: '',
		id: 'SCROLL_TO_TOP',
		components: [],
		componentType: 'Anchor',
	},
	SCROLL_TO_BOTTOM: {
		id: 'SCROLL_TO_BOTTOM',
		type: 'Component',
		layout: {},
		metaData: {},
		parent: null,
		styleId: '',
		components: [],
		componentType: 'Anchor',
	},
	FONTS: {
		id: 'FONTS',
		type: 'Component',
		componentType: 'FontRulersContainer',
		components: [],
		layout: {},
		metaData: {},
		parent: null,
		styleId: '',
	},
	main_MF: {
		components: [
			'SITE_STYLES',
			'SCROLL_TO_TOP',
			'site-root',
			'DYNAMIC_STRUCTURE_CONTAINER',
			'SCROLL_TO_BOTTOM',
			'FONTS',
		],
		componentType: 'DivWithChildren',
		id: 'main_MF',
		type: 'Component',
		layout: {},
		metaData: {},
		parent: null,
		styleId: '',
	},
})
